import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AbstractTranslatableAlertService, AuthSelector, CoreState, CustomerManagementSelector } from "@obg/ngx.core";
import { ignoreNil } from "@obg/rxjs";
import { combineLatest } from "rxjs";
import { distinctUntilChanged, filter, switchMap, take, pairwise, delay } from "rxjs/operators";

import { LoginYearlyReviewConfigService } from "./login-yearly-review.config";
import { LoginYearlyReviewContainer } from "./login-yearly-review.container";

@Injectable({
	providedIn: "root",
})
export class LoginYearlyReviewService {
	constructor(
		private store: Store<CoreState>,
		private loginYearlyReviewConfigService: LoginYearlyReviewConfigService,
		private translatableAlertService: AbstractTranslatableAlertService
	) {}

	initialize$() {
		return combineLatest([
			this.store.select(AuthSelector.isAuthenticated).pipe(ignoreNil(), distinctUntilChanged(), pairwise()),
			this.store
				.select(CustomerManagementSelector.shouldProfileValidationOccur)
				.pipe(ignoreNil(), distinctUntilChanged()),
		]).pipe(
			filter(([[prevAuth, nextAuth], shouldProfileValidationOccur]) => {
				const isAuthenticated = !prevAuth && nextAuth;
				const isLoginYearlyReviewDialogEnabled =
					this.loginYearlyReviewConfigService.isLoginYearlyReviewDialogEnabled();

				return isAuthenticated && shouldProfileValidationOccur && isLoginYearlyReviewDialogEnabled;
			}),
			take(1),
			// Delay is needed to push the opening of the dialog after the mobile login back navigation is done.
			delay(0),
			switchMap(() => this.openDialog$())
		);
	}

	private openDialog$() {
		const LOGIN_YEARLY_REVIEW_ALERT_ID = "login-yearly-review-dialog-id";
		const LOGIN_YEARLY_REVIEW_ALERT_TEST_ID = "login-yearly-review-dialog-id";

		return this.translatableAlertService.open$(
			{
				id: LOGIN_YEARLY_REVIEW_ALERT_ID,
				testId: LOGIN_YEARLY_REVIEW_ALERT_TEST_ID,
				messageComponent: LoginYearlyReviewContainer,
				mustBeInteracted: true,
				hideClose: true,
				dialogConfig: {
					disableClose: true,
				},
			},
			[]
		);
	}
}
